module.exports = __webpack_public_path__ + "static/media/woman-with-cat.084291c3.svg";